<script>
  import { Link } from '@inertiajs/svelte'
  import { cn } from '@lib/utils'

  let { text, path, Icon, class: className, children, iconProps = {}, ...restProps } = $props()

  let baseClasses = "text-gray-600/80 text-smaller hover:text-gray-700/80 not-last:border-b not-last:pb-2 border-gray-100 flex items-center gap-2"
  let classes = $derived(cn(baseClasses, className))
</script>

<Link href={path} class={classes} {...restProps}>
  {#if children}
    {@render children()}
  {:else}
    {#if Icon}
      <Icon size={14} class="text-gray-500/80" {...iconProps} />
    {/if}
    <p>{text}</p>
  {/if}
</Link>